<template>
  <div class="bankid-same-device-container" data-external="eid-modal-bankid-same-device-container">
    <FriedParagraph>{{ t('to-sign-the-document-open-the-bankid-application') }}</FriedParagraph>
    <a :href="bankIdAutoStartUrl" target="_blank">
      <FriedButton
        :button-type="ButtonType.Secondary"
        class="open-bank-id-button"
        data-external="bankid-open-button"
      >
        <template #leftIcon>
          <EIdIcon :type="EIdIconType.BankId" />
        </template>
        {{ $t('open-bankid') }}
      </FriedButton>
    </a>
  </div>
</template>

<script lang="ts">
import { ButtonType } from '@getaccept/fried-tofu';
import { SigningHelper as SigningShared } from '@getaccept/lib-shared/src/signature/helpers/signing.helper';
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import EIdIcon from '../../EIdIcon.vue';
import type { BankId } from '../../../types/bankid';
import { SigningHelper } from '../../../helpers/signing.helper';
import { BankIdStep } from '../../../types/enums/bankid-se';
import { EIdIconType } from '../../../types/enums/eid-icon-type';

export default defineComponent({
  components: {
    EIdIcon,
  },
  props: {
    bankId: {
      type: Object as PropType<BankId>,
      required: true,
    },
    jwt: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const bankIdAutoStartUrl = computed(() => {
      const baseUrl = 'bankid:///?autostarttoken=';
      if (SigningShared.isIOS() && !SigningShared.isSafari()) {
        const redirectUrl: string = SigningHelper.getBankIDiOSRedirectUrl(props.bankId, props.jwt);
        return `${baseUrl}${props.bankId.autoStartToken}&redirect=${encodeURIComponent(
          redirectUrl
        )}`;
      }
      return `${baseUrl}${props.bankId.autoStartToken}&redirect=null`;
    });

    return {
      bankIdAutoStartUrl,
      BankIdStep,
      ButtonType,
      EIdIconType,
      t,
    };
  },
});
</script>
<style lang="scss" scoped>
.bankid-same-device-container {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-100);

  .open-bank-id-button {
    width: 100%;
  }
}
</style>
